import { render, staticRenderFns } from "./supplierNews.vue?vue&type=template&id=33186317&"
import script from "./supplierNews.vue?vue&type=script&lang=js&"
export * from "./supplierNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports